import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-final-form';

import {SaveButton, TextField, Panel, Button} from '../../common';
import {
  EMAIL_REGEXP,
} from '../../../configs/constants';
import {
  emailIdInvalid,
} from '../../../configs/messages';
import {goHistoryBack} from '../../../utils/index';

export default class ForgotPassword extends Component {
  static propTypes = {
    forgotPasswordRequest: PropTypes.func.isRequired,
  };

  onFormSubmit = (values) => {
    const {forgotPasswordRequest} = this.props;
    forgotPasswordRequest(values);
  };

  onBackButtonClick = () => {
    goHistoryBack();
  }

  validateEmail = (email = '') => {
    if (!email.match(EMAIL_REGEXP)) {
      return emailIdInvalid;
    }

    return null;
  };

  render() {
    return (
      <Panel
        title="Oh No! You forgot your password"
        size="m"
        cls="forgot-pass"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, pristine, invalid}) => (
            <form className="form form_m" onSubmit={handleSubmit}>
              <p>Please enter your email address to get a password reset link.</p>
              <hr/>
              <TextField
                label="Email"
                name="email"
                type="email"
                maxLength={256}
                validatorsArray={[this.validateEmail]}
                required
              />
              <div className="row row_space-between">
                <Button size="xl" text="Back" handler={this.onBackButtonClick}/>
                <SaveButton size="xl" type="submit" text="Send" disabled={pristine || invalid}/>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
